import React, { createContext, useContext } from "react";
import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/analytics";
import "firebase/storage";

const fbConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const FirebaseContext = createContext(app);

export const FirebaseProvider: React.FC = ({ children }) => {
  if (!app.apps.length) {
    app.initializeApp(fbConfig);

    // app.functions().useFunctionsEmulator("http://localhost:5000");
    // app.analytics();
  }
  return <FirebaseContext.Provider value={app}>{children}</FirebaseContext.Provider>;
};

//returns firebase state from context when callen from a component.
export const useFirebase = () => {
  return useContext(FirebaseContext);
};
